module.exports = __webpack_public_path__ + "media/images/icon__profile-6f403bfbafbbcd7c48a9629366987597.png";